export { MaterialSymbol } from './MaterialSymbol';
